var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MRow',{staticClass:"flex-1",attrs:{"gutter":0}},[_c('MCol',{staticClass:"flex flex-col",attrs:{"size":12}},[_c('FlotoCrudContainer',{ref:"realtedKbRef",attrs:{"fetch-fn":_vm.fetchRelatedKb,"scrollable":false,"as-table":"","columns":_vm.columns,"hide-table-headers":"","message-size":"small"},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('ResourceListTitle',{attrs:{"name":item.name,"subject":item.subject,"created-at":item.updatedAt,"open-in-new-tab":"","external-link":"","link":_vm.$modules.getModuleRoute(
                _vm.isPortalLogin ? 'support-portal' : _vm.$constants.KNOWLEDGE,
                'read',
                {
                  params: { id: item.id },
                }
              )}})],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }